import { TemplateKind } from '../Model/TemplateKind';
import { TemplateMode } from '../Model/TemplateMode';
import { SliderState } from '../Model/SliderState';
var MobileManager = /** @class */ (function () {
    function MobileManager(mobile) {
        this._mobile = null;
        this._mobile = mobile;
    }
    MobileManager.prototype.show = function (widget, appearance, showCb) {
        var content = widget.render(TemplateKind.Mobile, TemplateMode.Mobile);
        var params = {
            kind: TemplateKind.Mobile,
            state: SliderState.Button,
            position: appearance.position,
            bottomIndent: appearance.bottomIndent,
            priority: 1
        };
        this._mobile.show(params, content, showCb);
    };
    MobileManager.prototype.resize = function (appearance, state, size) {
        var params = {
            kind: TemplateKind.Mobile,
            state: state,
            position: appearance.position,
            size: size,
            bottomIndent: appearance.bottomIndent
        };
        this._mobile.resize(params);
    };
    MobileManager.prototype.hide = function () {
        var params = {
            kind: TemplateKind.Mobile
        };
        this._mobile.hide(params);
    };
    MobileManager.prototype.destroy = function (appearance) {
        var params = {
            kind: TemplateKind.Mobile,
            position: appearance.position
        };
        this._mobile.destroy(params);
    };
    MobileManager.prototype.canShow = function () {
        return true;
    };
    return MobileManager;
}());
export { MobileManager };
